import { render, staticRenderFns } from "./PermissionSelectorSkeleton.vue?vue&type=template&id=495e5c07"
import script from "./PermissionSelectorSkeleton.vue?vue&type=script&lang=js"
export * from "./PermissionSelectorSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PermissionSelectorSkeleton.vue?vue&type=style&index=0&id=495e5c07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports